(function () {
  'use strict';

  var isSafari =
    typeof navigator !== 'undefined' &&
    /Safari/i.test(navigator.userAgent) &&
    !/Chrome|CriOS|Chromium|Edg|OPR|Android/i.test(navigator.userAgent);

  function getProductAddButton(root) {
    var scope = root || document;
    var hydeRoot = scope.matches && scope.matches('[data-hyde-pdp]') ? scope : scope.querySelector('[data-hyde-pdp]');

    if (hydeRoot) {
      var isMobile = window.matchMedia('(max-width: 768px)').matches;
      var hydeBtn = hydeRoot.querySelector(
        isMobile ? '.hyde-pdp__add-btn--mobile' : '.hyde-pdp__add-btn--desktop'
      );
      if (hydeBtn) return hydeBtn;
    }

    return scope.querySelector('.rabitat-product-page__add-btn');
  }

  function setProductAddButtonLoading(isLoading, root) {
    var btn = getProductAddButton(root);
    if (!btn) return;

    if (!btn.dataset.defaultLabel) {
      btn.dataset.defaultLabel = btn.getAttribute('data-default-label') || 'Add to Cart';
    }

    var soldOutLabel = btn.getAttribute('data-sold-out-label') || 'Sold out';

    if (isLoading) {
      btn.dataset.wasDisabled = btn.disabled ? 'true' : 'false';
      btn.disabled = true;
      btn.textContent = 'Adding...';
      btn.setAttribute('aria-busy', 'true');
      return;
    }

    btn.removeAttribute('aria-busy');
    var isSoldOut = btn.dataset.wasDisabled === 'true';
    btn.disabled = isSoldOut;
    btn.textContent = isSoldOut ? soldOutLabel : btn.dataset.defaultLabel;
  }

  function collectFormProperties(form) {
    var properties = {};
    if (!form) return properties;

    form.querySelectorAll('[name^="properties["]').forEach(function (input) {
      var match = input.name.match(/^properties\[(.+)\]$/);
      if (match && input.value) {
        properties[match[1]] = input.value;
      }
    });

    return properties;
  }

  function notifyCartUpdated(cart) {
    document.dispatchEvent(new CustomEvent('cart:updated'));

    if (cart && typeof cart.item_count === 'number') {
      document.dispatchEvent(
        new CustomEvent('rabitat:cart:updated', {
          detail: { item_count: cart.item_count, cart: cart }
        })
      );
    }
  }

  function readCartCountFromHeader() {
    var countEl = document.querySelector('[data-rabitat-cart-count]');
    if (!countEl || countEl.hidden) return 0;
    return parseInt(countEl.textContent, 10) || 0;
  }

  function syncCartAfterAdd(lineItem) {
    if (window.RabitatCart && typeof window.RabitatCart.handleMutationResult === 'function') {
      window.RabitatCart.handleMutationResult(lineItem, {
        open: true,
        focus: false,
        animate: false
      });
      return;
    }

    var addedQty = lineItem && lineItem.quantity ? lineItem.quantity : 1;
    var optimisticCount = readCartCountFromHeader() + addedQty;

    if (window.RabitatCart && typeof window.RabitatCart.openDrawerForAdd === 'function') {
      window.RabitatCart.openDrawerForAdd({ open: true, focus: false, animate: false });
    } else if (typeof window.openCartDrawer === 'function') {
      window.openCartDrawer({ focus: false, animate: false });
    }

    if (window.RabitatCart && typeof window.RabitatCart.updateCartCount === 'function') {
      window.RabitatCart.updateCartCount(optimisticCount);
    }

    fetch('/cart.js', {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin'
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Cart request failed');
        return response.json();
      })
      .then(function (cart) {
        notifyCartUpdated(cart);
      })
      .catch(function () {
        notifyCartUpdated({ item_count: optimisticCount });
      });
  }

  function finishAddToCart(lineItem, root) {
    setProductAddButtonLoading(false, root);
    syncCartAfterAdd(lineItem);
  }

  window.RabitatCart = window.RabitatCart || {};
  window.RabitatCart.setProductAddButtonLoading = setProductAddButtonLoading;
  window.RabitatCart.finishAddToCart = finishAddToCart;
  window.RabitatCart.syncCartAfterAdd = syncCartAfterAdd;
  window.RabitatCart.notifyUpdated = notifyCartUpdated;

  function initProductPage(root) {
    if (!root || root.dataset.productInitialized === 'true') return;
    root.dataset.productInitialized = 'true';

    var form = root.querySelector('.rabitat-product-page__form, .rabitat-product-page__controls');
    var variantInput = form && form.querySelector('[data-product-variant-id]');
    var quantityInput = form && form.querySelector('[data-product-quantity]');
    var priceEl = root.querySelector('[data-product-price]');
    var compareEl = root.querySelector('[data-product-compare]');
    var colourLabel = root.querySelector('[data-product-colour-label]');
    var mainImage = root.querySelector('.rabitat-product-page__hero-image');
    var heroContainer = root.querySelector('[data-product-hero]');
    var thumbsContainer = root.querySelector('[data-product-thumbs]');
    var thumbsArrow = root.querySelector('[data-product-thumbs-arrow]');
    var variantsJsonEl = root.querySelector('[data-product-variants]');
    var mediaJsonEl = root.querySelector('[data-product-media]');
    var boundariesJsonEl = root.querySelector('[data-product-media-boundaries]');
    var variantMediaRangesEl = root.querySelector('[data-product-variant-media-ranges]');
    var productTitle = root.dataset.productTitle || 'Product image';
    var variants = [];
    var mediaCatalog = [];
    var mediaBoundaries = [];
    var variantMediaRanges = [];

    function resolveImageAlt(image) {
      if (image && image.alt) return image.alt;
      return productTitle;
    }

    function isVideoMedia(item) {
      return !!(item && item.mediaType === 'video');
    }

    function galleryItemSignature(item) {
      if (!item) return '';
      return String(item.id || item.full || '') + ':' + (item.mediaType || 'image');
    }

    function parseVideoSources(raw) {
      if (!raw) return [];
      try {
        return JSON.parse(raw);
      } catch (e) {
        return [];
      }
    }

    function pickPreferredVideoSources(sources) {
      if (!sources || !sources.length) return [];
      var mp4 = sources.filter(function (source) {
        if (!source || !source.url) return false;
        if (source.mimeType === 'video/mp4') return true;
        return source.url.indexOf('.mp4') !== -1;
      });
      return mp4.length ? mp4 : sources;
    }

    function pauseAllHeroVideos() {
      var track = getHeroTrack();
      if (!track) return;
      track.querySelectorAll('.rabitat-product-page__hero-video').forEach(function (video) {
        video.pause();
      });
    }

    function unloadVideoElement(video) {
      if (!video) return;
      video.pause();
      while (video.firstChild) {
        video.removeChild(video.firstChild);
      }
      video.removeAttribute('src');
      video.dataset.sourcesLoaded = '';
      try {
        video.load();
      } catch (e) {}
    }

    function unloadInactiveVideoSlides(activeIndex) {
      var track = getHeroTrack();
      if (!track) return;
      track.querySelectorAll('[data-product-hero-slide]').forEach(function (slide, index) {
        if (index === activeIndex) return;
        if (slide.getAttribute('data-media-type') !== 'video') return;
        unloadVideoElement(slide.querySelector('.rabitat-product-page__hero-video'));
      });
    }

    function loadVideoElement(video, sources) {
      if (!video) return;
      if (video.dataset.sourcesLoaded === 'true') return;

      appendVideoSources(video, pickPreferredVideoSources(sources));
      video.dataset.sourcesLoaded = 'true';
      try {
        video.load();
      } catch (e) {}
    }

    function getSlideVideoSources(slide, video) {
      if (slide && slide.dataset.videoSources) {
        return parseVideoSources(slide.dataset.videoSources);
      }
      if (video && video.dataset.videoSources) {
        return parseVideoSources(video.dataset.videoSources);
      }
      return [];
    }

    function updateVideoControlState(wrap, video) {
      if (!wrap || !video) return;

      var playIcon = wrap.querySelector('.rabitat-product-page__hero-video-toggle-icon--play');
      var pauseIcon = wrap.querySelector('.rabitat-product-page__hero-video-toggle-icon--pause');
      var playBtn = wrap.querySelector('[data-hero-video-play]');
      var isPaused = video.paused;

      if (playIcon) playIcon.hidden = !isPaused;
      if (pauseIcon) pauseIcon.hidden = isPaused;
      if (playBtn) {
        playBtn.setAttribute('aria-label', isPaused ? 'Play video' : 'Pause video');
        playBtn.setAttribute('aria-pressed', isPaused ? 'false' : 'true');
      }
    }

    function bindVideoWrapEvents(wrap) {
      var video = wrap && wrap.querySelector('.rabitat-product-page__hero-video');
      if (!video || wrap.dataset.videoControlsBound === 'true') return;

      wrap.dataset.videoControlsBound = 'true';
      ['play', 'pause'].forEach(function (eventName) {
        video.addEventListener(eventName, function () {
          updateVideoControlState(wrap, video);
        });
      });
      updateVideoControlState(wrap, video);
    }

    function buildHeroVideoControls() {
      var toggle = document.createElement('button');
      toggle.type = 'button';
      toggle.className = 'rabitat-product-page__hero-video-toggle';
      toggle.setAttribute('data-hero-video-play', '');
      toggle.setAttribute('aria-label', 'Play video');
      toggle.setAttribute('aria-pressed', 'false');
      toggle.innerHTML =
        '<span class="rabitat-product-page__hero-video-toggle-icon rabitat-product-page__hero-video-toggle-icon--play" aria-hidden="true">' +
        '<svg width="18" height="18" viewBox="0 0 18 18" fill="none"><path d="M6.5 4.5L13.5 9L6.5 13.5V4.5Z" fill="currentColor"/></svg></span>' +
        '<span class="rabitat-product-page__hero-video-toggle-icon rabitat-product-page__hero-video-toggle-icon--pause" aria-hidden="true" hidden>' +
        '<svg width="18" height="18" viewBox="0 0 18 18" fill="none"><path d="M5.5 4.5H8V13.5H5.5V4.5ZM10 4.5H12.5V13.5H10V4.5Z" fill="currentColor"/></svg></span>';
      return toggle;
    }

    function wrapHeroVideo(video, sources) {
      var wrap = document.createElement('div');
      wrap.className = 'rabitat-product-page__hero-video-wrap';
      if (sources) {
        video.dataset.videoSources = JSON.stringify(sources);
      }
      wrap.appendChild(video);
      wrap.appendChild(buildHeroVideoControls());
      bindVideoWrapEvents(wrap);
      return wrap;
    }

    function playHeroVideo(video, sources) {
      if (!video) return Promise.resolve();

      loadVideoElement(video, sources);
      video.muted = true;

      var wrap = video.closest('.rabitat-product-page__hero-video-wrap');
      var playback = window.RabitatVideoPlayback;

      if (playback) {
        return playback.safePlay(video).then(function () {
          if (wrap) updateVideoControlState(wrap, video);
        });
      }

      var playPromise = video.play();
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(function () {});
      }
      if (wrap) updateVideoControlState(wrap, video);
      return Promise.resolve();
    }

    function syncHeroVideoPlayback(activeIndex) {
      pauseAllHeroVideos();
      unloadInactiveVideoSlides(activeIndex);

      var track = getHeroTrack();
      if (!track) return;

      var slides = track.querySelectorAll('[data-product-hero-slide]');
      var slide = slides[activeIndex];
      if (!slide || slide.getAttribute('data-media-type') !== 'video') return;

      var slideVideo = slide.querySelector('.rabitat-product-page__hero-video');
      if (!slideVideo) return;

      playHeroVideo(slideVideo, getSlideVideoSources(slide, slideVideo));
    }

    function preloadGalleryItem(item) {
      return new Promise(function (resolve) {
        if (!item || !item.full) {
          resolve();
          return;
        }

        var preload = new Image();
        preload.decoding = 'async';
        preload.onload = preload.onerror = function () {
          resolve();
        };
        preload.src = item.full;
      });
    }

    function appendVideoSources(video, sources) {
      (sources || []).forEach(function (source) {
        if (!source || !source.url) return;
        var sourceEl = document.createElement('source');
        sourceEl.src = source.url;
        if (source.mimeType) sourceEl.type = source.mimeType;
        video.appendChild(sourceEl);
      });
    }

    function buildHeroVideoElement(item, index) {
      var video = document.createElement('video');
      video.className = 'rabitat-product-page__hero-video';
      video.setAttribute('playsinline', '');
      video.muted = true;
      video.loop = true;
      video.preload = 'none';
      if (item.full) video.setAttribute('poster', item.full);
      video.setAttribute('aria-label', resolveImageAlt(item));
      return video;
    }

    function buildHeroVideoElementFromThumb(thumb) {
      var video = document.createElement('video');
      video.className = 'rabitat-product-page__hero-video';
      video.setAttribute('playsinline', '');
      video.muted = true;
      video.loop = true;
      video.preload = 'none';
      if (thumb.dataset.fullSrc) video.setAttribute('poster', thumb.dataset.fullSrc);
      video.setAttribute('aria-label', thumb.dataset.alt || productTitle);
      return video;
    }

    function buildHeroSlide(item, index) {
      var slide = document.createElement('div');
      slide.className = 'rabitat-product-page__hero-slide';
      slide.setAttribute('data-product-hero-slide', '');

      if (isVideoMedia(item)) {
        slide.setAttribute('data-media-type', 'video');
        if (item.id != null) slide.setAttribute('data-media-id', String(item.id));
        if (item.videoSources) {
          slide.dataset.videoSources = JSON.stringify(item.videoSources);
        }
        slide.appendChild(wrapHeroVideo(buildHeroVideoElement(item, index), item.videoSources));
        return slide;
      }

      var img = document.createElement('img');
      img.className = 'rabitat-product-page__hero-image';
      img.alt = resolveImageAlt(item);
      img.loading = index === 0 ? 'eager' : 'lazy';
      img.decoding = 'async';
      if (window.RabitatResponsiveImage) {
        window.RabitatResponsiveImage.apply(img, item.full, {
          preset: 'product',
          loading: img.loading,
          alt: img.alt,
        });
      } else {
        img.src = item.full;
      }
      slide.appendChild(img);
      return slide;
    }

    function getFirstHeroSlide() {
      var track = getHeroTrack();
      if (!track) return null;

      var slide = track.querySelector('[data-product-hero-slide]');
      if (slide) return slide;

      slide = document.createElement('div');
      slide.className = 'rabitat-product-page__hero-slide';
      slide.setAttribute('data-product-hero-slide', '');
      if (typeof track.replaceChildren === 'function') {
        track.replaceChildren(slide);
      } else {
        track.innerHTML = '';
        track.appendChild(slide);
      }
      return slide;
    }

    function setMainVideoFromThumb(thumb) {
      var slide = getFirstHeroSlide();
      if (!slide || !thumb) return;

      pauseAllHeroVideos();

      slide.setAttribute('data-media-type', 'video');
      slide.dataset.videoSources = thumb.dataset.videoSources || '';

      var sources = parseVideoSources(thumb.dataset.videoSources);
      var poster = thumb.dataset.fullSrc || '';
      var alt = thumb.dataset.alt || productTitle;

      var img = slide.querySelector('.rabitat-product-page__hero-image');
      if (img) img.remove();

      var wrap = slide.querySelector('.rabitat-product-page__hero-video-wrap');
      var video;

      if (wrap) {
        video = wrap.querySelector('.rabitat-product-page__hero-video');
        unloadVideoElement(video);
      } else {
        wrap = document.createElement('div');
        wrap.className = 'rabitat-product-page__hero-video-wrap';
        video = buildHeroVideoElementFromThumb(thumb);
        wrap.appendChild(video);
        wrap.appendChild(buildHeroVideoControls());
        bindVideoWrapEvents(wrap);
        slide.appendChild(wrap);
      }

      if (poster) video.setAttribute('poster', poster);
      video.setAttribute('aria-label', alt);
      if (sources.length) video.dataset.videoSources = JSON.stringify(sources);

      playHeroVideo(video, sources);
    }

    function initHeroVideoControls(pageRoot) {
      if (!pageRoot || pageRoot.dataset.heroVideoControlsInit === 'true') return;
      pageRoot.dataset.heroVideoControlsInit = 'true';

      pageRoot.querySelectorAll('.rabitat-product-page__hero-video-wrap').forEach(function (wrap) {
        bindVideoWrapEvents(wrap);
      });

      pageRoot.addEventListener('click', function (event) {
        var playBtn = event.target.closest('[data-hero-video-play]');
        if (playBtn && pageRoot.contains(playBtn)) {
          event.preventDefault();
          event.stopPropagation();
          var playWrap = playBtn.closest('.rabitat-product-page__hero-video-wrap');
          var playVideo = playWrap && playWrap.querySelector('.rabitat-product-page__hero-video');
          if (!playVideo) return;

          if (playVideo.paused) {
            var playSlide = playVideo.closest('[data-product-hero-slide]');
            playHeroVideo(playVideo, getSlideVideoSources(playSlide, playVideo));
          } else {
            playVideo.pause();
          }
          updateVideoControlState(playWrap, playVideo);
        }
      });
    }

    if (variantsJsonEl) {
      try {
        variants = JSON.parse(variantsJsonEl.textContent);
      } catch (e) {
        variants = [];
      }
    }

    if (mediaJsonEl) {
      try {
        mediaCatalog = JSON.parse(mediaJsonEl.textContent);
      } catch (e) {
        mediaCatalog = [];
      }
    }

    if (boundariesJsonEl) {
      try {
        mediaBoundaries = JSON.parse(boundariesJsonEl.textContent);
        mediaBoundaries.sort(function (a, b) {
          return a - b;
        });
      } catch (e) {
        mediaBoundaries = [];
      }
    }

    if (variantMediaRangesEl) {
      try {
        variantMediaRanges = JSON.parse(variantMediaRangesEl.textContent);
      } catch (e) {
        variantMediaRanges = [];
      }
    }

    initDescriptionToggle(root);

    function initDescriptionToggle(pageRoot) {
      var wrap = pageRoot.querySelector('[data-product-description]');
      if (!wrap || wrap.dataset.descriptionInitialized === 'true') return;
      wrap.dataset.descriptionInitialized = 'true';

      var content = wrap.querySelector('[data-product-description-content]');
      var toggle = wrap.querySelector('[data-product-description-toggle]');
      var moreLabel = wrap.querySelector('[data-product-description-more]');
      var lessLabel = wrap.querySelector('[data-product-description-less]');
      if (!content || !toggle) return;

      function syncToggleVisibility() {
        content.classList.add('is-collapsed');
        var needsToggle = content.scrollHeight > content.clientHeight + 1;

        if (!needsToggle) {
          content.classList.remove('is-collapsed');
          toggle.hidden = true;
          if (moreLabel) moreLabel.hidden = false;
          if (lessLabel) lessLabel.hidden = true;
          return;
        }

        toggle.hidden = false;
      }

      function setCollapsed(collapsed) {
        content.classList.toggle('is-collapsed', collapsed);
        if (moreLabel) moreLabel.hidden = !collapsed;
        if (lessLabel) lessLabel.hidden = collapsed;
      }

      setCollapsed(true);
      syncToggleVisibility();

      window.addEventListener('resize', syncToggleVisibility);

      toggle.addEventListener('click', function () {
        setCollapsed(content.classList.contains('is-collapsed') ? false : true);
      });
    }

    function findVariant(id) {
      return variants.find(function (v) {
        return String(v.id) === String(id);
      });
    }

    function getHeroViewport() {
      return heroContainer ? heroContainer.querySelector('[data-product-hero-viewport]') : null;
    }

    function getHeroTrack() {
      return heroContainer ? heroContainer.querySelector('[data-product-hero-track]') : null;
    }

    function getHeroImage() {
      if (heroContainer) {
        return heroContainer.querySelector('.rabitat-product-page__hero-image:not(.rabitat-product-page__hero-image--placeholder)');
      }
      return mainImage;
    }

    function setMainImage(src, alt) {
      pauseAllHeroVideos();
      unloadInactiveVideoSlides(-1);
      var slide = getFirstHeroSlide();
      if (!slide || !src) return;

      slide.removeAttribute('data-media-type');
      delete slide.dataset.videoSources;

      var videoWrap = slide.querySelector('.rabitat-product-page__hero-video-wrap');
      if (videoWrap) {
        unloadVideoElement(videoWrap.querySelector('.rabitat-product-page__hero-video'));
        videoWrap.remove();
      }

      var img = slide.querySelector('.rabitat-product-page__hero-image');
      if (!img) {
        img = document.createElement('img');
        img.className = 'rabitat-product-page__hero-image';
        img.loading = 'eager';
        slide.appendChild(img);
      }

      img.alt = alt || productTitle;

      if (window.RabitatResponsiveImage) {
        window.RabitatResponsiveImage.apply(img, src, {
          preset: 'product',
          loading: 'eager',
          alt: img.alt,
        });
      } else {
        img.removeAttribute('srcset');
        img.removeAttribute('sizes');
        img.src = src;
      }
    }

    function scrollHeroToIndex(index, smooth) {
      var viewport = getHeroViewport();
      var track = getHeroTrack();
      var slides = track ? track.querySelectorAll('[data-product-hero-slide]') : [];
      if (!viewport || !track || !slides.length) return;

      var slide = slides[index];
      if (!slide) return;

      viewport.scrollTo({
        left: slide.offsetLeft - track.offsetLeft,
        behavior: smooth ? 'smooth' : 'auto',
      });
    }

    function galleryDebug(type, detail) {
      if (!window.RABITAT_PDP_GALLERY_DEBUG) return;
      console.log('[PDP GALLERY][' + type + ']', detail || '');
    }

    function getGalleryLayoutKey() {
      return (isHorizontalThumbs() ? 'horizontal' : 'vertical') + ':' + window.innerWidth;
    }

    var galleryLayoutKey = getGalleryLayoutKey();

    function shouldRemountGalleryForLayoutChange() {
      var nextKey = getGalleryLayoutKey();
      if (nextKey === galleryLayoutKey) return false;
      galleryLayoutKey = nextKey;
      galleryDebug('LAYOUT CHANGE', nextKey);
      return true;
    }

    function syncThumbActive(activeIndex) {
      getThumbButtons().forEach(function (btn, index) {
        var isActive = index === activeIndex;
        btn.classList.toggle('is-active', isActive);
        btn.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });
    }

    function bindHeroScroll() {
      var viewport = getHeroViewport();
      if (!viewport || viewport.dataset.heroScrollBound === 'true') return;
      viewport.dataset.heroScrollBound = 'true';

      var heroScrollTicking = false;
      var lastHeroScrollIndex = -1;
      var lastHeroScrollLeft = viewport.scrollLeft;

      viewport.addEventListener(
        'scroll',
        function () {
          if (!isHorizontalThumbs()) return;

          var scrollLeft = viewport.scrollLeft;
          if (scrollLeft === lastHeroScrollLeft) return;
          lastHeroScrollLeft = scrollLeft;

          if (heroScrollTicking) return;
          heroScrollTicking = true;
          window.requestAnimationFrame(function () {
            heroScrollTicking = false;

            var track = getHeroTrack();
            var slides = track ? track.querySelectorAll('[data-product-hero-slide]') : [];
            if (!slides.length) return;

            var nearestIndex = 0;
            var nearestDistance = Infinity;

            slides.forEach(function (slide, index) {
              var distance = Math.abs(slide.offsetLeft - track.offsetLeft - scrollLeft);
              if (distance < nearestDistance) {
                nearestDistance = distance;
                nearestIndex = index;
              }
            });

            galleryDebug('GALLERY HORIZONTAL SCROLL', {
              scrollLeft: scrollLeft,
              nearestIndex: nearestIndex,
            });

            syncThumbActive(nearestIndex);

            if (nearestIndex !== lastHeroScrollIndex) {
              lastHeroScrollIndex = nearestIndex;
              syncHeroVideoPlayback(nearestIndex);
            }
          });
        },
        { passive: true }
      );
    }

    function updateMobileHeroSlidesInPlace(uniqueImages, activeIndex) {
      var track = getHeroTrack();
      if (!track) return false;

      var slides = track.querySelectorAll('[data-product-hero-slide]');
      if (slides.length !== uniqueImages.length || !uniqueImages.length) return false;

      pauseAllHeroVideos();

      uniqueImages.forEach(function (item, index) {
        var slide = slides[index];
        if (!slide) return;

        if (isVideoMedia(item)) {
          slide.setAttribute('data-media-type', 'video');
          if (item.id != null) slide.setAttribute('data-media-id', String(item.id));
          if (item.videoSources) {
            slide.dataset.videoSources = JSON.stringify(item.videoSources);
          } else {
            delete slide.dataset.videoSources;
          }

          var heroImg = slide.querySelector('.rabitat-product-page__hero-image');
          if (heroImg) heroImg.remove();

          var wrap = slide.querySelector('.rabitat-product-page__hero-video-wrap');
          var video;

          if (!wrap) {
            wrap = document.createElement('div');
            wrap.className = 'rabitat-product-page__hero-video-wrap';
            video = buildHeroVideoElement(item, index);
            wrap.appendChild(video);
            wrap.appendChild(buildHeroVideoControls());
            bindVideoWrapEvents(wrap);
            slide.appendChild(wrap);
          } else {
            video = wrap.querySelector('.rabitat-product-page__hero-video');
            unloadVideoElement(video);
            if (item.full) video.setAttribute('poster', item.full);
            video.setAttribute('aria-label', resolveImageAlt(item));
          }
          return;
        }

        slide.removeAttribute('data-media-type');
        delete slide.dataset.videoSources;

        var videoWrap = slide.querySelector('.rabitat-product-page__hero-video-wrap');
        if (videoWrap) {
          unloadVideoElement(videoWrap.querySelector('.rabitat-product-page__hero-video'));
          videoWrap.remove();
        }

        var img = slide.querySelector('.rabitat-product-page__hero-image');
        if (!img) {
          img = document.createElement('img');
          img.className = 'rabitat-product-page__hero-image';
          slide.appendChild(img);
        }

        img.alt = resolveImageAlt(item);
        img.loading = index === 0 ? 'eager' : 'lazy';
        img.decoding = 'async';

        if (window.RabitatResponsiveImage) {
          window.RabitatResponsiveImage.apply(img, item.full, {
            preset: 'product',
            loading: img.loading,
            alt: img.alt,
          });
        } else {
          img.removeAttribute('srcset');
          img.removeAttribute('sizes');
          img.src = item.full;
        }
      });

      scrollHeroToIndex(activeIndex, false);
      syncHeroVideoPlayback(activeIndex);
      return true;
    }

    function updateThumbsInPlace(uniqueImages, activeIndex) {
      var existing = getThumbButtons();
      if (existing.length !== uniqueImages.length || !uniqueImages.length) return false;

      uniqueImages.forEach(function (image, index) {
        var btn = existing[index];
        if (!btn) return;

        var isVideo = isVideoMedia(image);
        btn.classList.toggle('rabitat-product-page__thumb--video', isVideo);
        btn.dataset.mediaType = image.mediaType || 'image';
        btn.dataset.fullSrc = image.full;
        btn.dataset.alt = resolveImageAlt(image);
        btn.setAttribute('aria-label', (isVideo ? 'Show video ' : 'Show image ') + (index + 1));

        if (isVideo && image.videoSources) {
          btn.dataset.videoSources = JSON.stringify(image.videoSources);
        } else {
          delete btn.dataset.videoSources;
        }

        var thumbImg = btn.querySelector('img');
        if (thumbImg && normalizeGallerySrc(thumbImg.src) !== normalizeGallerySrc(image.thumb)) {
          thumbImg.src = image.thumb;
          thumbImg.alt = resolveImageAlt(image);
        }

        var playBadge = btn.querySelector('.rabitat-product-page__thumb-play');
        if (isVideo && !playBadge) {
          playBadge = document.createElement('span');
          playBadge.className = 'rabitat-product-page__thumb-play';
          playBadge.setAttribute('aria-hidden', 'true');
          playBadge.innerHTML =
            '<svg width="10" height="12" viewBox="0 0 10 12" fill="none">' +
            '<path d="M1 1L9 6L1 11V1Z" fill="currentColor"/>' +
            '</svg>';
          btn.appendChild(playBadge);
        } else if (!isVideo && playBadge) {
          playBadge.remove();
        }
      });

      syncThumbActive(activeIndex);
      return true;
    }

    function replaceTrackSlides(track, slides) {
      if (!track || !slides || !slides.length) return;
      if (typeof track.replaceChildren === 'function') {
        track.replaceChildren.apply(track, slides);
        return;
      }
      track.innerHTML = '';
      slides.forEach(function (slide) {
        track.appendChild(slide);
      });
    }

    function mountHeroGallery(images, activeIndex) {
      var track = getHeroTrack();
      if (!track) return;

      var uniqueImages = dedupeImages(images);
      if (!uniqueImages.length) return;

      activeIndex = activeIndex || 0;

      if (isHorizontalThumbs()) {
        var existingSlides = track.querySelectorAll('[data-product-hero-slide]');
        if (existingSlides.length === uniqueImages.length && track.dataset.rabitatHeroMounted === 'true') {
          galleryDebug('GALLERY REMOUNT SKIPPED', {
            reason: 'slides already mounted',
            count: existingSlides.length,
          });
          scrollHeroToIndex(activeIndex, false);
          syncHeroVideoPlayback(activeIndex);
          return;
        }

        galleryDebug('GALLERY REMOUNT', { slideCount: uniqueImages.length, activeIndex: activeIndex });

        var mobileSlides = uniqueImages.map(function (image, index) {
          return buildHeroSlide(image, index);
        });
        replaceTrackSlides(track, mobileSlides);
        track.dataset.rabitatHeroMounted = 'true';
        scrollHeroToIndex(activeIndex, false);
        bindHeroScroll();
        syncHeroVideoPlayback(activeIndex);
        return;
      }

      track.dataset.rabitatHeroMounted = '';

      var item = uniqueImages[activeIndex] || uniqueImages[0];
      if (!item) return;

      replaceTrackSlides(track, [buildHeroSlide(item, 0)]);

      if (isVideoMedia(item)) {
        syncHeroVideoPlayback(0);
      }
    }

    function renderHeroGallery(images, activeIndex) {
      var uniqueImages = dedupeImages(images);
      if (!uniqueImages.length) return;

      activeIndex = activeIndex || 0;
      var activeItem = uniqueImages[activeIndex] || uniqueImages[0];

      preloadGalleryItem(activeItem).then(function () {
        mountHeroGallery(uniqueImages, activeIndex);
      });
    }

    function mediaIndexById(mediaId) {
      if (!mediaId) return -1;
      for (var i = 0; i < mediaCatalog.length; i++) {
        if (String(mediaCatalog[i].id) === String(mediaId)) {
          return i;
        }
      }
      return -1;
    }

    function resolveVariantMediaIndex(variant) {
      if (!variant) return -1;
      if (variant.featured_media_index != null) {
        return variant.featured_media_index;
      }
      return mediaIndexById(variant.featured_media_id);
    }

    function getVariantMediaBoundaryIndices() {
      if (variantMediaRanges.length) {
        var rangeBoundaries = variantMediaRanges
          .map(function (range) {
            return range.start;
          })
          .filter(function (index) {
            return index != null && index >= 0;
          });

        rangeBoundaries.sort(function (a, b) {
          return a - b;
        });

        return rangeBoundaries.filter(function (index, position, list) {
          return position === 0 || index !== list[position - 1];
        });
      }

      if (mediaBoundaries.length) {
        return mediaBoundaries;
      }

      var seen = {};
      var boundaries = [];

      variants.forEach(function (variant) {
        var index = resolveVariantMediaIndex(variant);
        if (index < 0 || seen[index]) return;
        seen[index] = true;
        boundaries.push(index);
      });

      boundaries.sort(function (a, b) {
        return a - b;
      });

      return boundaries;
    }

    function getUnavailableMediaIndexSet(selectedVariantId) {
      var blocked = {};

      variantMediaRanges.forEach(function (range) {
        if (range.available) return;
        if (String(range.id) === String(selectedVariantId)) return;
        if (range.start == null || range.end == null) return;

        for (var index = range.start; index < range.end; index++) {
          blocked[index] = true;
        }
      });

      return blocked;
    }

    function filterUnavailableVariantImages(images, selectedVariantId) {
      if (!variantMediaRanges.length || !images.length) {
        return images;
      }

      var blocked = getUnavailableMediaIndexSet(selectedVariantId);

      return images.filter(function (image) {
        var index = image.index;

        if (index == null) {
          index = mediaIndexById(image.id);
        }

        if (index < 0) return true;
        return !blocked[index];
      });
    }

    function imagesForVariant(variantId) {
      if (!mediaCatalog.length) return [];

      var variant = findVariant(variantId);
      if (!variant) return [];

      var images = [];

      if (variant.media_indices && variant.media_indices.length) {
        images = variant.media_indices
          .map(function (index) {
            return mediaCatalog[index];
          })
          .filter(Boolean);
      } else if (
        variant.media_start_index != null &&
        variant.media_end_index != null &&
        variant.media_end_index > variant.media_start_index
      ) {
        images = mediaCatalog.slice(variant.media_start_index, variant.media_end_index);
      } else {
        var start = resolveVariantMediaIndex(variant);

        if (start < 0) {
          if (variant.featured_media_id) {
            var featuredIndex = mediaIndexById(variant.featured_media_id);
            if (featuredIndex >= 0) {
              images = [mediaCatalog[featuredIndex]];
            }
          }

          if (!images.length && variant.featured_image_full) {
            var featuredMatch = mediaCatalog.filter(function (image) {
              return image.full === variant.featured_image_full;
            });
            if (featuredMatch.length) {
              images = featuredMatch;
            } else {
              images = [
                {
                  id: variant.featured_image_full,
                  full: variant.featured_image_full,
                  thumb: variant.featured_image_full,
                  alt: productTitle,
                },
              ];
            }
          }

          if (!images.length) {
            images = mediaCatalog.length ? [mediaCatalog[0]] : [];
          }
        } else {
          var boundaries = getVariantMediaBoundaryIndices();
          var end = mediaCatalog.length;

          boundaries.some(function (boundary) {
            if (boundary > start) {
              end = boundary;
              return true;
            }
            return false;
          });

          images = mediaCatalog.slice(start, end);
        }
      }

      return filterUnavailableVariantImages(images, variantId);
    }

    function dedupeImages(images) {
      var seen = {};
      return (images || []).filter(function (image) {
        var key = String(image.id || image.full);
        if (seen[key]) return false;
        seen[key] = true;
        return true;
      });
    }

    function normalizeGallerySrc(src) {
      return String(src || '')
        .replace(/^https?:/i, '')
        .replace(/&amp;/g, '&')
        .trim();
    }

    function getThumbButtons() {
      return Array.prototype.slice.call(root.querySelectorAll('[data-product-thumb]'));
    }

    function getActiveThumbIndex(thumbs) {
      for (var i = 0; i < thumbs.length; i++) {
        if (thumbs[i].classList.contains('is-active')) return i;
      }
      return 0;
    }

    function selectThumbByIndex(index) {
      var thumbs = getThumbButtons();
      if (!thumbs.length) return;

      var nextIndex = ((index % thumbs.length) + thumbs.length) % thumbs.length;
      var thumb = thumbs[nextIndex];

      if (isHorizontalThumbs()) {
        scrollHeroToIndex(nextIndex, true);
        syncHeroVideoPlayback(nextIndex);
      } else if (thumb.dataset.mediaType === 'video') {
        setMainVideoFromThumb(thumb);
      } else {
        setMainImage(thumb.dataset.fullSrc, thumb.dataset.alt || '');
      }

      syncThumbActive(nextIndex);

      if (isHorizontalThumbs()) {
        thumb.scrollIntoView({ behavior: 'smooth', inline: 'nearest', block: 'nearest' });
      }

      updateHeroArrowVisibility();
    }

    function updateHeroArrowVisibility() {
      var heroPrev = root.querySelector('[data-product-hero-prev]');
      var heroNext = root.querySelector('[data-product-hero-next]');

      if (heroPrev) {
        heroPrev.hidden = true;
        heroPrev.setAttribute('aria-hidden', 'true');
      }

      if (heroNext) {
        heroNext.hidden = true;
        heroNext.setAttribute('aria-hidden', 'true');
      }
    }

    function isHorizontalThumbs() {
      if (!thumbsContainer) return false;
      return window.matchMedia('(max-width: 768px)').matches;
    }

    function scrollThumbsToStart() {
      if (!thumbsContainer) return;
      if (isHorizontalThumbs()) {
        if (typeof thumbsContainer.scrollTo === 'function') {
          thumbsContainer.scrollTo({ left: 0, behavior: 'smooth' });
        } else {
          thumbsContainer.scrollLeft = 0;
        }
      } else if (typeof thumbsContainer.scrollTo === 'function') {
        thumbsContainer.scrollTo({ top: 0, behavior: 'smooth' });
      } else {
        thumbsContainer.scrollTop = 0;
      }
      updateThumbsArrowVisibility();
    }

    function updateThumbsArrowVisibility() {
      updateHeroArrowVisibility();

      if (!thumbsArrow || !thumbsContainer) return;

      if (isHorizontalThumbs()) {
        thumbsArrow.hidden = true;
        thumbsArrow.setAttribute('aria-hidden', 'true');
        return;
      }

      var imageCount = thumbsContainer.querySelectorAll('[data-product-thumb]').length;
      var canScroll = imageCount > 6;

      if (!canScroll) {
        thumbsArrow.hidden = true;
        thumbsArrow.setAttribute('aria-hidden', 'true');
        return;
      }

      thumbsArrow.hidden = false;
      thumbsArrow.setAttribute('aria-hidden', 'false');

      var atEnd =
        thumbsContainer.scrollTop + thumbsContainer.clientHeight >=
        thumbsContainer.scrollHeight - 4;

      thumbsArrow.style.opacity = atEnd ? '0' : '1';
    }

    function bindThumbsScroll() {
      if (!thumbsContainer || thumbsContainer.dataset.thumbsScrollBound === 'true') return;
      thumbsContainer.dataset.thumbsScrollBound = 'true';
      thumbsContainer.addEventListener('scroll', updateThumbsArrowVisibility);
      window.addEventListener('resize', updateThumbsArrowVisibility);
    }

    function buildThumbButton(image, index) {
      var btn = document.createElement('button');
      var isVideo = isVideoMedia(image);
      btn.type = 'button';
      btn.className =
        'rabitat-product-page__thumb' +
        (index === 0 ? ' is-active' : '') +
        (isVideo ? ' rabitat-product-page__thumb--video' : '');
      btn.setAttribute('data-product-thumb', '');
      btn.dataset.mediaType = image.mediaType || 'image';
      btn.dataset.fullSrc = image.full;
      btn.dataset.alt = resolveImageAlt(image);
      btn.setAttribute('aria-label', (isVideo ? 'Show video ' : 'Show image ') + (index + 1));
      btn.setAttribute('aria-pressed', index === 0 ? 'true' : 'false');
      if (isVideo && image.videoSources) {
        btn.dataset.videoSources = JSON.stringify(image.videoSources);
      }

      var img = document.createElement('img');
      img.src = image.thumb;
      img.alt = resolveImageAlt(image);
      img.loading = index === 0 ? 'eager' : 'lazy';
      img.decoding = 'async';
      btn.appendChild(img);

      if (isVideo) {
        var playBadge = document.createElement('span');
        playBadge.className = 'rabitat-product-page__thumb-play';
        playBadge.setAttribute('aria-hidden', 'true');
        playBadge.innerHTML =
          '<svg width="10" height="12" viewBox="0 0 10 12" fill="none">' +
          '<path d="M1 1L9 6L1 11V1Z" fill="currentColor"/>' +
          '</svg>';
        btn.appendChild(playBadge);
      }

      return btn;
    }

    function replaceThumbButtons(buttons) {
      if (!thumbsContainer) return;
      if (typeof thumbsContainer.replaceChildren === 'function') {
        thumbsContainer.replaceChildren.apply(thumbsContainer, buttons);
        return;
      }
      thumbsContainer.innerHTML = '';
      buttons.forEach(function (btn) {
        thumbsContainer.appendChild(btn);
      });
    }

    function renderThumbs(images, options) {
      if (!thumbsContainer) return;

      options = options || {};
      var uniqueImages = dedupeImages(images);
      var activeIndex = options.activeIndex != null ? options.activeIndex : 0;

      if (options.skipIfUnchanged && uniqueImages.length) {
        var existingThumbs = getThumbButtons();
        if (existingThumbs.length) {
          var existingSignature = existingThumbs
            .map(function (btn) {
              return (btn.dataset.mediaType || 'image') + ':' + normalizeGallerySrc(btn.dataset.fullSrc);
            })
            .join('|');
          var newSignature = uniqueImages
            .map(function (image) {
              return galleryItemSignature(image) + ':' + normalizeGallerySrc(image.full);
            })
            .join('|');

          if (existingSignature === newSignature) {
            bindThumbsScroll();
            bindHeroScroll();

            var track = getHeroTrack();
            var slideCount = track ? track.querySelectorAll('[data-product-hero-slide]').length : 0;
            var prerenderedSlidesMatch = slideCount === uniqueImages.length;

            if (isHorizontalThumbs()) {
              if (!prerenderedSlidesMatch) {
                renderHeroGallery(uniqueImages, activeIndex);
              } else {
                syncThumbActive(activeIndex);
                scrollHeroToIndex(activeIndex, false);
                syncHeroVideoPlayback(activeIndex);
              }
            } else {
              var slideNodes = track ? track.querySelectorAll('[data-product-hero-slide]') : [];

              if (!prerenderedSlidesMatch || slideNodes.length > 1) {
                renderHeroGallery(uniqueImages, activeIndex);
              } else {
                syncThumbActive(activeIndex);
              }
            }

            requestAnimationFrame(updateThumbsArrowVisibility);
            return;
          }
        }
      }

      if (!uniqueImages.length) {
        replaceThumbButtons([]);
        return;
      }

      var firstItem = uniqueImages[activeIndex] || uniqueImages[0];

      preloadGalleryItem(firstItem).then(function () {
        var thumbsUpdatedInPlace = updateThumbsInPlace(uniqueImages, activeIndex);
        if (!thumbsUpdatedInPlace) {
          var thumbButtons = uniqueImages.map(function (image, index) {
            return buildThumbButton(image, index);
          });
          replaceThumbButtons(thumbButtons);
        }

        scrollThumbsToStart();
        bindThumbsScroll();

        if (isHorizontalThumbs()) {
          if (!updateMobileHeroSlidesInPlace(uniqueImages, activeIndex)) {
            mountHeroGallery(uniqueImages, activeIndex);
          } else {
            bindHeroScroll();
          }
        } else {
          var item = uniqueImages[activeIndex] || uniqueImages[0];
          var track = getHeroTrack();
          var slides = track ? track.querySelectorAll('[data-product-hero-slide]') : [];
          var thumbButtons = getThumbButtons();

          if (slides.length === 1 && item) {
            if (isVideoMedia(item)) {
              setMainVideoFromThumb(thumbButtons[activeIndex]);
            } else {
              setMainImage(item.full, resolveImageAlt(item));
            }
            syncThumbActive(activeIndex);
          } else if (item) {
            mountHeroGallery(uniqueImages, activeIndex);
          }
        }

        requestAnimationFrame(updateThumbsArrowVisibility);
      });
    }

    function scrollToGallery() {
      if (!window.matchMedia('(max-width: 768px)').matches) return;
      if (root.hasAttribute('data-hyde-pdp')) return;

      var media = root.querySelector('.rabitat-product-page__media');
      if (!media) return;

      media.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    function isProductFullySoldOut() {
      if (root.dataset.productAvailable === 'false') return true;
      return !variants.some(function (v) {
        return v.available;
      });
    }

    function updatePurchaseActions(variant) {
      var isHydePdp = root.hasAttribute('data-hyde-pdp');
      var pdpSignupOnly = root.hasAttribute('data-pdp-signup-only');
      var variantSignupWhenUnavailable = root.hasAttribute('data-variant-signup-when-unavailable');
      var addBtns = isHydePdp
        ? root.querySelectorAll('.rabitat-product-page__add-btn')
        : [getProductAddButton(root)].filter(Boolean);
      var addBtn = addBtns[0] || null;
      var actions = root.querySelector('[data-product-actions]');
      var buyNow = root.querySelector('#gokwik-buy-now') || root.querySelector('[data-gokwik-buy-now-trigger]');
      var signupTrigger = root.querySelector('[data-signup-trigger]');
      if (!addBtn && !buyNow && !signupTrigger) return;

      if (pdpSignupOnly) {
        var disabledCta = root.querySelector('[data-pdp-signup-disabled-cta]');
        var signupLabel =
          (disabledCta && disabledCta.getAttribute('data-product-signup-label')) ||
          (signupTrigger && signupTrigger.getAttribute('data-product-signup-label')) ||
          'Coming Soon/Sign Up';
        var variantId = variant && variant.id ? String(variant.id) : '';

        root.querySelectorAll('[data-pdp-signup-disabled-cta]').forEach(function (btn) {
          btn.hidden = false;
          btn.disabled = true;
          btn.setAttribute('aria-disabled', 'true');
          if (variantId) btn.setAttribute('data-current-variant-id', variantId);
          var btnSignupLabel = btn.getAttribute('data-product-signup-label') || signupLabel;
          var hydeLabel = btn.querySelector('[data-hyde-add-btn-label], [data-hyde-sticky-add-label]');
          if (hydeLabel) hydeLabel.textContent = btnSignupLabel;
          else btn.textContent = btnSignupLabel;
        });

        root.querySelectorAll('[data-signup-trigger]').forEach(function (btn) {
          btn.hidden = true;
          btn.disabled = true;
        });

        root
          .querySelectorAll(
            '[data-hyde-quick-add-trigger], [data-hyde-sticky-quick-add], .rabitat-product-page__add-btn[name="add"]'
          )
          .forEach(function (btn) {
            btn.hidden = true;
            btn.disabled = true;
          });

        if (buyNow) {
          buyNow.hidden = true;
          buyNow.disabled = true;
        }

        root.querySelectorAll('[data-hyde-customisable-badge]').forEach(function (badge) {
          badge.hidden = true;
        });

        if (actions) {
          actions.classList.remove('rabitat-product-page__actions--sold-out');
          actions.classList.add('rabitat-product-page__actions--signup');
        }

        return;
      }

      var defaultLabel = addBtn ? addBtn.getAttribute('data-default-label') || 'Add to Cart' : 'Add to Cart';
      var soldOutLabel = addBtn ? addBtn.getAttribute('data-sold-out-label') || 'Sold out' : 'Sold out';
      var productSoldOut = isProductFullySoldOut();
      var checkoutAvailable =
        variant && variant.checkout_available != null ? !!variant.checkout_available : !!(variant && variant.available);
      var isAvailable = !!(variant && variant.available);
      var showBuyNow = checkoutAvailable && !productSoldOut;

      if (variantSignupWhenUnavailable && signupTrigger) {
        var cartBtn =
          root.querySelector('.rabitat-product-page__add-btn[name="add"]') ||
          root.querySelector('.rabitat-product-page__add-btn:not([data-signup-trigger]):not([data-gokwik-buy-now-trigger])');
        var blinkitBtn = root.querySelector('.rabitat-product-page__blinkit-btn');

        if (isAvailable) {
          signupTrigger.hidden = true;

          if (cartBtn) {
            cartBtn.hidden = false;
            cartBtn.disabled = false;
            cartBtn.textContent = cartBtn.getAttribute('data-default-label') || defaultLabel;
            cartBtn.dataset.wasDisabled = 'false';
          }

          if (buyNow) {
            buyNow.hidden = false;
            buyNow.disabled = !showBuyNow;
            if (showBuyNow) {
              buyNow.removeAttribute('aria-disabled');
              buyNow.textContent =
                buyNow.getAttribute('data-product-buy-now-label') ||
                buyNow.getAttribute('data-rabitat-buy-now-label') ||
                'Buy Now';
            } else {
              buyNow.setAttribute('aria-disabled', 'true');
              buyNow.textContent = soldOutLabel;
            }

            var checkoutVariantId = variant && (variant.checkout_id || variant.id);
            if (checkoutVariantId) {
              buyNow.setAttribute('data-current-variant-id', String(checkoutVariantId));
            }
          }

          if (blinkitBtn) {
            blinkitBtn.hidden = false;
          }
        } else {
          signupTrigger.hidden = false;

          if (cartBtn) {
            cartBtn.hidden = true;
            cartBtn.disabled = true;
            cartBtn.dataset.wasDisabled = 'true';
          }

          if (buyNow) {
            buyNow.hidden = true;
            buyNow.disabled = true;
            buyNow.setAttribute('aria-disabled', 'true');
          }

          if (blinkitBtn) {
            blinkitBtn.hidden = true;
          }
        }

        if (actions) {
          actions.classList.toggle('rabitat-product-page__actions--sold-out', !isAvailable);
        }

        signupTrigger.setAttribute('data-current-variant-id', String(variant.id));
        return;
      }

      if (!addBtn && !buyNow) return;

      addBtns.forEach(function (currentBtn) {
        if (!currentBtn) return;

        currentBtn.dataset.defaultLabel = defaultLabel;
        var hydeAddLabel = currentBtn.querySelector('[data-hyde-add-btn-label]');

        if (isAvailable) {
          currentBtn.disabled = false;
          if (hydeAddLabel) {
            hydeAddLabel.textContent = defaultLabel;
          } else {
            currentBtn.textContent = defaultLabel;
          }
          currentBtn.dataset.wasDisabled = 'false';
          if (actions) actions.classList.remove('rabitat-product-page__actions--sold-out');
        } else {
          currentBtn.disabled = true;
          if (hydeAddLabel) {
            hydeAddLabel.textContent = soldOutLabel;
          } else {
            currentBtn.textContent = soldOutLabel;
          }
          currentBtn.dataset.wasDisabled = 'true';
          if (actions) actions.classList.add('rabitat-product-page__actions--sold-out');
        }
      });

      root.querySelectorAll('[data-hyde-customisable-badge]:not(.hyde-pdp__customisable-badge--sticky)').forEach(function (badge) {
        badge.hidden = !isAvailable;
      });

      if (!addBtn && actions && !isAvailable) {
        actions.classList.add('rabitat-product-page__actions--sold-out');
      } else if (!addBtn && actions) {
        actions.classList.remove('rabitat-product-page__actions--sold-out');
      }

      if (buyNow) {
        var buyNowLabel =
          buyNow.getAttribute('data-product-buy-now-label') ||
          buyNow.getAttribute('data-rabitat-buy-now-label') ||
          'Buy Now';

        if (buyNow.hasAttribute('data-gokwik-buy-now-trigger')) {
          var checkoutVariantId = variant && (variant.checkout_id || variant.id);
          if (checkoutVariantId) {
            buyNow.setAttribute('data-current-variant-id', String(checkoutVariantId));
          }

          buyNow.disabled = !showBuyNow;
          if (!showBuyNow) {
            buyNow.setAttribute('aria-disabled', 'true');
            buyNow.textContent = soldOutLabel;
          } else {
            buyNow.removeAttribute('aria-disabled');
            buyNow.textContent = buyNowLabel;
          }
        } else {
          buyNow.hidden = !showBuyNow;
          buyNow.style.display = showBuyNow ? '' : 'none';
          buyNow.disabled = !showBuyNow;
        }
      }
    }

    function selectVariant(variant, options) {
      options = options || {};
      if (!variant || !variantInput) return;

      variantInput.value = variant.id;
      variantInput.dispatchEvent(new Event('change', { bubbles: true }));

      if (priceEl) {
        priceEl.textContent = variant.price_formatted || '';
      }

      if (compareEl) {
        if (variant.compare_at_price > variant.price && variant.compare_formatted) {
          compareEl.textContent = variant.compare_formatted;
          compareEl.hidden = false;
          compareEl.classList.remove('rabitat-product-page__compare--hidden');
        } else {
          compareEl.textContent = '';
          compareEl.hidden = true;
          compareEl.classList.add('rabitat-product-page__compare--hidden');
        }
      }

      var ppcdWidget = root.querySelector('[data-ppcod-widget]');
      if (ppcdWidget) {
        var balanceEl = ppcdWidget.querySelector('[data-ppcod-balance]');
        if (balanceEl && variant.ppcod_balance_formatted) {
          balanceEl.textContent = String(variant.ppcod_balance_formatted)
            .replace(/<[^>]*>/g, '')
            .replace(/₹\s+/g, '₹')
            .replace(/Rs\.\s+/g, 'Rs.')
            .trim();
        }
      }

      root.querySelectorAll('[data-product-colour-label]').forEach(function (el) {
        if (variant.option1) {
          el.textContent = variant.option1;
        }
      });

      var variantImages = imagesForVariant(variant.id);
      var galleryInitialized = root.dataset.galleryInitialized === 'true';
      renderThumbs(variantImages, {
        skipIfUnchanged: !galleryInitialized && root.dataset.galleryPrerendered === 'true',
        activeIndex: 0,
      });
      root.dataset.galleryInitialized = 'true';

      root.querySelectorAll('[data-product-swatch]').forEach(function (btn) {
        var isActive = String(btn.value) === String(variant.id);
        btn.classList.toggle('is-active', isActive);
        btn.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });

      updatePurchaseActions(variant);

      var signupTrigger = root.querySelector('[data-signup-trigger]');
      if (signupTrigger && variant) {
        signupTrigger.setAttribute('data-current-variant-id', String(variant.id));
      }

      document.dispatchEvent(
        new CustomEvent('rabitat:variant:changed', {
          detail: { variant: variant }
        })
      );

      document.dispatchEvent(
        new CustomEvent('variant:changed', {
          detail: { variant: variant }
        })
      );

      if (options.scrollToGallery) {
        scrollToGallery();
      }
    }

    root.addEventListener('click', function (event) {
      var heroPrev = event.target.closest('[data-product-hero-prev]');
      if (heroPrev && root.contains(heroPrev)) {
        event.preventDefault();
        selectThumbByIndex(getActiveThumbIndex(getThumbButtons()) - 1);
        return;
      }

      var heroNext = event.target.closest('[data-product-hero-next]');
      if (heroNext && root.contains(heroNext)) {
        event.preventDefault();
        selectThumbByIndex(getActiveThumbIndex(getThumbButtons()) + 1);
        return;
      }

      var thumb = event.target.closest('[data-product-thumb]');
      if (thumb && root.contains(thumb)) {
        event.preventDefault();
        var thumbs = getThumbButtons();
        var thumbIndex = thumbs.indexOf(thumb);
        if (thumbIndex >= 0) {
          selectThumbByIndex(thumbIndex);
        }
        return;
      }

      var swatch = event.target.closest('[data-product-swatch]');
      if (swatch && root.contains(swatch)) {
        event.preventDefault();
        selectVariant(findVariant(swatch.value), { scrollToGallery: true });
        return;
      }

      var qtyMinus = event.target.closest('[data-product-qty-minus]');
      if (qtyMinus && quantityInput) {
        event.preventDefault();
        var next = Math.max(1, parseInt(quantityInput.value, 10) - 1 || 1);
        quantityInput.value = next;
        root.querySelector('[data-product-qty-value]').textContent = next;
        return;
      }

      var qtyPlus = event.target.closest('[data-product-qty-plus]');
      if (qtyPlus && quantityInput) {
        event.preventDefault();
        var plusNext = Math.max(1, parseInt(quantityInput.value, 10) + 1 || 2);
        quantityInput.value = plusNext;
        root.querySelector('[data-product-qty-value]').textContent = plusNext;
        return;
      }

      var gokwikTrigger = event.target.closest('[data-gokwik-buy-now-trigger]');
      if (gokwikTrigger && root.contains(gokwikTrigger)) {
        event.preventDefault();
        if (gokwikTrigger.disabled || gokwikTrigger.getAttribute('aria-disabled') === 'true') return;

        var gokwikVariantId = gokwikTrigger.getAttribute('data-current-variant-id');
        if (window.RabitatGokwikCheckout && window.RabitatGokwikCheckout.buyNowWithVariant) {
          window.RabitatGokwikCheckout.buyNowWithVariant(gokwikVariantId, gokwikTrigger);
        } else {
          window.alert('Checkout is loading. Please try again in a moment.');
        }
        return;
      }

      var signupTrigger = event.target.closest('[data-signup-trigger]');
      if (signupTrigger && root.contains(signupTrigger)) {
        if (root.hasAttribute('data-pdp-signup-only')) {
          event.preventDefault();
          return;
        }
        event.preventDefault();

        var signupSection = root.closest('[data-signup-collection]');
        var variantId = signupTrigger.getAttribute('data-current-variant-id');
        var selectedVariant = findVariant(variantId) || variants[0];

        document.dispatchEvent(
          new CustomEvent('rabitat:signup:open', {
            detail: {
              productId: root.getAttribute('data-product-id') || '',
              productTitle: root.getAttribute('data-product-title') || '',
              productHandle: root.getAttribute('data-product-handle') || '',
              variant: selectedVariant,
              sectionRoot: signupSection,
            },
          })
        );
      }
    });

    if (form) {
      form.addEventListener('submit', function (event) {
        var submitter = event.submitter;
        if (!submitter || submitter.name !== 'add') return;

        event.preventDefault();
        if (submitter.disabled || !variantInput || !quantityInput) return;

        setProductAddButtonLoading(true, root);

        var addPayload = {
          id: variantInput.value,
          quantity: Math.max(1, parseInt(quantityInput.value, 10) || 1),
          properties: collectFormProperties(form)
        };

        if (window.RabitatCart && typeof window.RabitatCart.withCartSections === 'function') {
          addPayload = window.RabitatCart.withCartSections(addPayload);
        }

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(addPayload)
        })
          .then(function (response) {
            if (!response.ok) {
              return response.json().then(function (data) {
                throw new Error((data && data.description) || 'Add to cart failed');
              });
            }
            return response.json();
          })
          .then(function (lineItem) {
            finishAddToCart(lineItem, root);
          })
          .catch(function () {
            alert('Unable to add to cart. Please try again.');
          })
          .finally(function () {
            setProductAddButtonLoading(false, root);
          });
      });
    }

    initHeroVideoControls(root);

    if (variantInput) {
      selectVariant(findVariant(variantInput.value));
    }

    window.addEventListener('resize', function () {
      if (!shouldRemountGalleryForLayoutChange()) {
        galleryDebug('RESIZE IGNORED', {
          innerWidth: window.innerWidth,
          innerHeight: window.innerHeight,
        });
        return;
      }

      var images = dedupeImages(
        getThumbButtons().map(function (btn) {
          return {
            full: btn.dataset.fullSrc,
            alt: btn.dataset.alt || 'Rabitat',
            id: btn.dataset.fullSrc,
          };
        })
      );

      if (images.length) {
        var activeIndex = getActiveThumbIndex(getThumbButtons());
        renderHeroGallery(images, activeIndex);
      }
    });
  }

  function initAll() {
    document.querySelectorAll('[data-product-page]').forEach(initProductPage);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    event.target.querySelectorAll('[data-product-page]').forEach(initProductPage);
  });
})();
